// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'
import { valueAsKm } from 'helpers/unitConversion'

// p is the band parameter object from redux-form

const prepInterferenceParameterForAPI = p => {
  const {
    interferenceProjectParameterId,
    objectiveId,
    propagationModel: { propagationModelId },
  } = p

  const analysisTypes = p.analysisTypes.map(t => +t)

  const frequencyWindow = castToFloat(p.frequencyWindow)
  const marginToObjective = castToFloat(p.marginToObjective)

  const keyholeRadiusKm = valueAsKm(p.keyholeRadius, p.keyholeRadiusUnit)
  const minimumProfileDistanceKm = valueAsKm(p.minimumProfileDistance, p.minimumProfileDistanceUnit)
  const minimumRadiusKm = valueAsKm(p.minimumRadius, p.minimumRadiusUnit)

  return {
    analysisTypes,
    frequencyWindow,
    interferenceProjectParameterId,
    keyholeRadiusKm,
    marginToObjective,
    minimumProfileDistanceKm,
    minimumRadiusKm,
    objectiveId,
    propagationModelId,
  }
}

export default prepInterferenceParameterForAPI
